var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 296,
    viewBox: "0 0 195 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3224_268535)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.7504 25.0305C105.574 129.289 131.414 335.123 176.989 377.899H97.7504H97.239H18C63.5749 335.123 89.4149 129.289 97.239 25.0305V18C97.3217 19.1757 97.4069 20.3665 97.4947 21.5719C97.5824 20.3665 97.6676 19.1757 97.7504 18V25.0305Z",
    fill: "url(#paint0_linear_3224_268535)",
    fillOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3224_268535",
    x: 0.618507,
    y: 0.618507,
    width: 193.752,
    height: 394.662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.69075,
    result: "effect1_foregroundBlur_3224_268535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3224_268535",
    x1: 97.2625,
    y1: 48.0959,
    x2: 99.9296,
    y2: 346.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0178903,
    stopColor: "#9AE7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635417,
    stopColor: "#9AE7FE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginShadow);
export default __webpack_public_path__ + "static/media/login-shadow.8aca6a19c55191c646680a4938380791.svg";
export { ForwardRef as ReactComponent };